<template>
  <span class="date-navigator">
    <i class="el-icon-arrow-left" @click="prevDay"></i>
    <el-date-picker
      v-model="dateValue"
      :type="type"
      size="mini"
      class="date-picker"
      :clearable="false"
      :format="displayFormat"
      :value-format="valueFormat"
      @change="onChange"></el-date-picker>
    <i class="el-icon-arrow-right" @click="nextDay"></i>
  </span>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    name: 'DateNavigator',
    props: {
      /** 绑定值，格式 YYYY-MM-DD */
      value: { type: String, required: true },
      /** 日期类型：date | month */
      type: { type: String, default: 'date' },
    },
    computed: {
      dateValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
      valueFormat() {
        return this.type === 'month' ? 'yyyy-MM' : 'yyyy-MM-dd';
      },
      displayFormat() {
        return this.type === 'month' ? 'yyyy-MM' : 'yyyy-MM-dd';
      },
    },
    methods: {
      prevDay() {
        const unit = this.type === 'month' ? 'month' : 'day';
        this.dateValue = dayjs(this.value).subtract(1, unit).format(this.valueFormat.toUpperCase());
        this.$emit('change', this.dateValue);
      },
      nextDay() {
        const unit = this.type === 'month' ? 'month' : 'day';
        this.dateValue = dayjs(this.value).add(1, unit).format(this.valueFormat.toUpperCase());
        this.$emit('change', this.dateValue);
      },
      onChange() {
        this.$emit('change', this.dateValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  .date-navigator {
    display: flex;
    align-items: center;
    gap: 6px;

    i {
      font-size: 14px;
      color: $text-secondary;
      cursor: pointer;

      &:hover {
        color: $accent-blue;
      }
    }

    .date-picker {
      width: 130px;

      ::v-deep .el-input__inner {
        background: transparent;
        border: 1px solid $bg-card-border;
        color: $text-secondary;
        font-size: 12px;
        height: 24px;
        line-height: 24px;
        padding: 0 8px;
      }

      ::v-deep .el-input__prefix {
        display: none;
      }
    }
  }
</style>
